import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col p-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex flex-wrap gap-2 mb-4" }
const _hoisted_5 = { class: "w-full block font-sourcesanspro-semibold text-md text-white/80 mb-2" }
const _hoisted_6 = { class: "flex flex-wrap gap-2" }

import { computed, watch } from 'vue';
import { IonSpinner } from '@ionic/vue';

import ChipButton from '@/shared/components/ChipButton.vue';
import useTagCollections from '@/shared/composables/useTagCollections';


export default /*@__PURE__*/_defineComponent({
  __name: 'TagCollections',
  props: {
	userTags: {
		type: Array<number>,
		required: false,
		default: function () {
			return [];
		},
	},
	autoSaveDelay: { type: Number, required: false, default: 0 },
},
  emits: ['update:tagsCount'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const { error, isError, isLoading, saveTags, selectChildTag, selectParentTag, tagsList, userTags } = useTagCollections(props.userTags, props.autoSaveDelay);

watch(userTags, (val) => emit('update:tagsCount', val.length), { deep: true });

const standaloneTags = computed(() => tagsList.value?.filter((t) => !t.children?.length) ?? []);
const parentTags = computed(() => tagsList.value?.filter((t) => t.children?.length) ?? []);

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

__expose({ saveTags });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(IonSpinner), { name: "dots" })
        ]))
      : _createCommentVNode("", true),
    (_unref(isError))
      ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(standaloneTags.value, (tag) => {
        return (_openBlock(), _createBlock(ChipButton, {
          label: tag.name.replace(/^#/, ''),
          selected: _unref(userTags).includes(tag.id),
          key: tag.id,
          onClick: ($event: any) => (_unref(selectParentTag)(null as any, tag))
        }, null, 8, ["label", "selected", "onClick"]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentTags.value, (tagParent) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tagParent.id,
        class: "mb-4"
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(capitalize(tagParent.name.replace(/^#/, ''))), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagParent.children, (tag) => {
            return (_openBlock(), _createBlock(ChipButton, {
              label: tag.name.replace(/^#/, ''),
              selected: _unref(userTags).includes(tag.id),
              key: tag.id,
              onClick: ($event: any) => (_unref(selectChildTag)(tag, tagParent))
            }, null, 8, ["label", "selected", "onClick"]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})